module.exports = __webpack_public_path__ + "img/yh.91e3a881.png";